import toast from 'react-hot-toast'

import { showApiError, useMutation } from '@fv/client-core'

import { shipperFetch } from '@/utils/shipperFetch'

import { useAddressBookCacheModifier } from './cache-modifiers'
import type { AddressBookListConfig } from './types'

type Args = {
  id: string
}
async function deleteAddress({ id }: Args): Promise<null> {
  return shipperFetch(`/addresses/${id}`, { method: 'DELETE' })
}

export function useDeleteAddress(config: AddressBookListConfig) {
  const { removeFromCache } = useAddressBookCacheModifier(config)

  return useMutation(deleteAddress, {
    onSettled: (_, error, { id }) => {
      if (error) return showApiError('Unable to delete address', error)

      removeFromCache(id)
      toast.success('Address deleted successfully.')
    },
  })
}
